import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Rx";
import { HttpVerb, HttpDataService } from "../http-data.service";
import {
  MessagePreference,
  SaveMessagePreference,
  SaveUserPreference,
  UserMessagePreference
} from "./model";
// import { NotificationHeadersPipe } from './notificationHeader.pipe';

@Injectable()
export class NotificationSettingService {
  msgPreferenceUrl: string = "/mobileproxy/messaging/v1/userPreferences/?grouped=true";

  constructor(private _httpDataService: HttpDataService) {}

  // FIX THIS -- BAD Practice. First parameter is bogus, use strongly typed generic controller to correct.
  public getMessagingPrefs(): Observable<UserMessagePreference> {
    return this._httpDataService.callApiEndPoint(
      null,
      this.msgPreferenceUrl,
      HttpVerb.Get
    );
  }

  // FIX THIS! -- should return Observable<SaveUserPreference>, but HttpDataService is screwed up.
  public saveMessagingPrefs(
    userPreference: UserMessagePreference
  ): Observable<UserMessagePreference> {
    let savePreferences = this.userPrefToSavePref(userPreference);
    return this._httpDataService.callApiEndPoint(
      savePreferences,
      this.msgPreferenceUrl,
      HttpVerb.Post
    );
  }

  private userPrefToSavePref(
    userPref: UserMessagePreference
  ): SaveUserPreference {
    console.log("user prefs:", userPref);
    let savePref = new SaveUserPreference();
    savePref.userId = userPref.userId;
    savePref.messagePreferences = [];

    userPref.messageTypeGroupings.forEach(grouping => {
      grouping.messagePreferences.forEach(msgPref => {
        let saveMsgPref = new SaveMessagePreference();
        saveMsgPref.messageName = msgPref.messageName;
        saveMsgPref.checkedProviderTypes = this.getChecked(msgPref);
        saveMsgPref.notCheckedProviderTypes = this.getUnchecked(msgPref);
        savePref.messagePreferences.push(saveMsgPref);
      });
    });
    // userPref.messageTypeGroupings.forEach(msgPref => {
    //   let saveMsgPref = new SaveMessagePreference();
    //     saveMsgPref.messageName = msgPref.messageName;
    //     saveMsgPref.checkedProviderTypes = this.getChecked(msgPref);
    //     saveMsgPref.notCheckedProviderTypes = this.getUnchecked(msgPref);
    //   savePref.messagePreferences.push(saveMsgPref);
    // });
    return savePref;
  }

  private getChecked(msgPref: MessagePreference): string[] {
    let checked: string[] = [];
    msgPref.providerTypes.forEach(providerType => {
      if (providerType.checked && !providerType.disabled)
        checked.push(providerType.name);
    });
    return checked;
  }

  private getUnchecked(msgPref: MessagePreference): string[] {
    let unChecked: string[] = [];
    msgPref.providerTypes.forEach(providerType => {
      if (!providerType.checked && !providerType.disabled)
        unChecked.push(providerType.name);
    });
    return unChecked;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/my-settings/notification/notification-settings.service.ts